import { ScrollText } from "lucide-react";
import ResourceShellTemplate from "./ResourceShellTemplate";

export default function ReleaseNotesShell() {
  return (
    <ResourceShellTemplate
      slug="release-notes"
      eyebrow="Resources · Release Notes"
      title="Every Build Pack."
      titleAccent="Versioned. Timestamped."
      subtitle="A chronological log of what shipped, with BP numbers, engine versions, and links to the underlying playbooks. Regulator-friendly."
      icon={ScrollText}
      previewLabel="Recently shipped"
      previewItems={[
        { title: "BP-026 · Platform Administration Console — Sessions 1–3", desc: "Backend RBAC, TOTP MFA, IP Allowlist, Support Console, Admin Frontend, guided 13-page tour.", meta: "BP-026 · Feb 2026" },
        { title: "BP-025 · AI Acquisition Coach — Sessions 1–2", desc: "Backend orchestrator with grounded LLM synthesis + Coach frontend at /v3/coach.", meta: "BP-025 · Feb 2026" },
        { title: "BP-024 · Market Intelligence Engine — UI Validation", desc: "ZIP-level health, strategy-fit rankings, 12-month forecast, opportunity alerts.", meta: "BP-024 · Feb 2026" },
        { title: "BP-023 · Portfolio Intelligence", desc: "Cash-flow health, cap rate, maturity radar, BRRRR refi opportunities for held assets.", meta: "BP-023 · Jan 2026" },
        { title: "BP-022 · Buyer Intelligence", desc: "Ranked, verified, funded buyers with track record capture and top-N matching.", meta: "BP-022 · Jan 2026" },
      ]}
    />
  );
}
